import React, { Component } from 'react';
 
import Account from '../components/account';
import Workouts from '../components/workouts';
import Dashboard from '../components/dashboard';
 
import { Drawer, Hidden, Box, Badge } from '@material-ui/core';
import AppBar from '@material-ui/core/AppBar';
import CssBaseline from '@material-ui/core/CssBaseline';
import Toolbar from '@material-ui/core/Toolbar';
import List from '@material-ui/core/List';
import Chip from '@material-ui/core/Chip';
import Typography from '@material-ui/core/Typography';
import MuiListItem from "@material-ui/core/ListItem";
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import withStyles from '@material-ui/core/styles/withStyles';
import PersonIcon from '@material-ui/icons/Person';
import Avatar from '@material-ui/core/Avatar';
import ExitToAppIcon from '@material-ui/icons/ExitToApp';
import CircularProgress from '@material-ui/core/CircularProgress';
import DashboardIcon from '@material-ui/icons/Dashboard';
import SubscriptionsIcon from '@material-ui/icons/Subscriptions';
import AllTrainers from '../components/admin/allTrainersList';
import PeopleIcon from '@material-ui/icons/People';
import IconButton from '@material-ui/core/IconButton';
import MenuIcon from '@material-ui/icons/Menu';
import AssignmentIcon from '@material-ui/icons/Assignment';

import "../App.css";
 
import { authMiddleWare } from '../util/auth'
 
import functionsApi from '../api';
import TrainingPlans from '../components/trainingPlans';
 
const drawerWidth = 300;
 
const styles = (theme) => ({
   root: {
       display: 'flex',
       backgroundColor: "#F6F7F7",
       fontFamily:"PNBold"
   },
   drawer: {
       [theme.breakpoints.up('sm')]: {
           width: drawerWidth,
           flexShrink: 0,
       },
   },
   appBar: {
       width: "100%",
       zIndex: 9999,
       background: "#F6F7F7",
       border: "0px",
       boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.0655321);"
   },
   // necessary for content to be below app bar
   toolbar: theme.mixins.toolbar,
   menuButton: {
       marginRight: theme.spacing(2),
       [theme.breakpoints.up('sm')]: {
           display: 'none',
       },
   },
   drawerPaper: {
       width: drawerWidth,
       background: "#F6F7F7",
       border: "0px",
       paddingLeft: "10px"
   },
   content: {
       flexGrow: 1,
       padding: theme.spacing(3),
   },
   avatar: {
       height: 100,
       width: 100,
       flexShrink: 0,
       flexGrow: 0,
       marginTop: 20
   },
   avatarSmall: {
       height: 30,
       width: 30,
       marginLeft: -10
   },
   uiProgess: {
       position: 'fixed',
       zIndex: '1000',
       height: '31px',
       width: '31px',
       left: '50%',
       top: '35%'
   },
   appbarIcons: {
       display: 'flex',
       justifyContent: 'space-between',
       width: '100%',
       height: '50px',
       alignItems: "center"
   },
   namePos: {
       position: 'absolute',
       right: '80px',
       top: '1px'
   },
   chipPos: {
       position: 'absolute',
       right: '88px',
       top: '30px'
 
   },
   darkIcon: {
       color:'black',
       "& .MuiListItemIcon-root": {
         color: "black"
       }
     },
   titlePos: {
       textAlign: "start"
   },
   itemBold: {
       fontWeight: "bold",
       fontFamily: "Arial",
       color: "black",
   } 
});
 
const ListItem = withStyles({
   root: {
     "&$selected": {
       backgroundColor: "#FFFFFF",
       borderRadius: "4px",
       borderLeft: "8px solid rgba(20, 118, 255, 1)",
       color: "rgba(0, 0, 0, 1)",
       "& .MuiListItemIcon-root": {
         color: "black"
       }
     },
     "&$selected:hover": {
       backgroundColor: "#FFFFFF",
       color: "black",
       borderLeft: "8px solid rgba(20, 118, 255, 1)",
       "& .MuiListItemIcon-root": {
         color: "black"
       }
     },
     "&:hover": {
       backgroundColor: "#FFFFFF",
       borderRadius: "4px",
       color: "black",
       "& .MuiListItemIcon-root": {
         color: "black"
       }
     }
   },
   selected: {}
 })(MuiListItem);
  
class home extends Component {
   state = {
       render: 0
   };
 
   loadAccountPage = () => {
       this.setState({ render: 3, drawerOpen: false });
   };
 
   loadWorkoutsPage = () => {
       this.setState({ render: 1, drawerOpen: false });
   };
 
   loadTrainingPlansPage = () => {
       this.setState({ render: 2, drawerOpen: false });
   };
 
   loadFirstPage = () => {
       this.setState({ render: 0, drawerOpen: false });
       this.state.menuSelectedIndex = 0;
   };
 
   handleDrawerToggle = () => {
       this.setState({ drawerOpen: !this.state.drawerOpen });
   };
 
   logoutHandler = (event) => {
       localStorage.removeItem('AuthToken');
       this.props.history.push('/login');
   };
   handleListItemClick = (index) => {
       this.state.menuSelectedIndex = index;
};
  
 
   constructor(props) {
       super(props);
 
       this.state = {
           render: this.state.render,
           name: '',
           profilePicture: '',
           uiLoading: true,
           imageLoading: false,
           drawerOpen: false,
           menuSelectedIndex: 0
       };
   }
 
   componentWillMount = () => {
       authMiddleWare(this.props.history);
 
       functionsApi
           .get('/getTrainerDetail')
           .then((response) => {
               this.setState({
                   name: response.data.userCredentials.name,
                   email: response.data.userCredentials.email,
                   isActive: response.data.userCredentials.isActive,
                   phoneNumber: response.data.userCredentials.phoneNumber,
                   country: response.data.userCredentials.country,
                   isAdmin: response.data.userCredentials.isAdmin,
                   id: response.data.userCredentials.id,
                   uiLoading: false,
                   profilePicture: response.data.userCredentials.url
               });
           })
           .catch((error) => {
               this.props.history.push('/login');
               this.setState({ errorMsg: 'Error in retrieving the data' });
 
           });
   };
 
   renderSwitch(param) {
 
       if (this.state.isAdmin) {
           switch (param) {
               case 0:
                   return <AllTrainers />
               case 1:
                   return <Workouts trainer={this.state} />;
               case 2:
                   return <TrainingPlans trainer={this.state} />
               case 3:
                   return <Account />;
               default:
                   return;
           }
       } else {
           switch (param) {
               case 0:
                   return <Dashboard />;
               case 1:
                   return <Workouts trainer={this.state} />;
               case 2:
                   return <TrainingPlans trainer={this.state} />
               case 3:
                   return <Account />;
               default:
                   return;
           }
       }
   };
 
 
   renderWorkoutsTabItem(param) {
       const { classes } = this.props;
 
       if (param === true) {
           return (
           <div className={classes.root}>
           <ListItem button key="Workouts" selected={this.state.menuSelectedIndex === 1} onClick={() => {this.loadWorkoutsPage(); this.handleListItemClick(1)}}>
               <ListItemIcon>
                   {' '}
                   <SubscriptionsIcon/>
                   {' '}
               </ListItemIcon>
               <ListItemText disableTypography className={classes.itemBold} primary="Workouts"/>
           </ListItem>
           </div>
           )
       }
       return;
   };
 
   renderTrainingPlansTabItem(param) {
       const { classes } = this.props;
       if (param === true) {
           return <ListItem button key="TrainingPlans" selected={this.state.menuSelectedIndex === 2} onClick={() => {this.loadTrainingPlansPage(); this.handleListItemClick(2)}}>
               <ListItemIcon>
                   {' '}
                   <AssignmentIcon />
                   {' '}
               </ListItemIcon>
               <ListItemText disableTypography className={classes.itemBold} primary="Training Plans" />
           </ListItem>
       }
       return;
   };
 
   renderTrainerTabs() {
       const { classes } = this.props;
       return <List>
           <ListItem button key="Home" selected={this.state.menuSelectedIndex === 0} onClick={() => {this.loadFirstPage(); this.handleListItemClick(0)}}>
               <ListItemIcon>
                   {' '}
                   <DashboardIcon />{' '}
               </ListItemIcon>
               <ListItemText disableTypography className={classes.itemBold} primary="Home" />
           </ListItem>
 
           {this.renderWorkoutsTabItem(this.state.isActive)}
           {this.renderTrainingPlansTabItem(this.state.isActive)}
           <ListItem button key="Account" selected={this.state.menuSelectedIndex === 3} onClick={() => {this.loadAccountPage(); this.handleListItemClick(3)}}>
               <ListItemIcon>
                   {' '}
                   <PersonIcon />{' '}
               </ListItemIcon>
               <ListItemText disableTypography className={classes.itemBold} primary="Account" />
           </ListItem>
 
           <ListItem button key="Logout" onClick={this.logoutHandler}>
               <ListItemIcon>
                   {' '}
                   <ExitToAppIcon />{' '}
               </ListItemIcon>
               <ListItemText disableTypography className={classes.itemBold} primary="Logout" />
           </ListItem>
       </List>
   }
 
   renderAdminTabs() {
       const { classes } = this.props;
       return <List>
           <ListItem button key="Trainers" selected={this.state.menuSelectedIndex === 0} onClick={() => {this.loadFirstPage(); this.handleListItemClick(0)}}>
               <ListItemIcon>
                   {' '}
                   <PeopleIcon />
                   {' '}
               </ListItemIcon>
               <ListItemText disableTypography className={classes.itemBold} primary="Trainers" />
           </ListItem>
 
           {this.renderWorkoutsTabItem(true)}
           {this.renderTrainingPlansTabItem(true)}
 
           <ListItem button key="Account" selected={this.state.menuSelectedIndex === 3} onClick={() => {this.loadAccountPage(); this.handleListItemClick(3)}}>             <ListItemIcon>
                   {' '}
                   <PersonIcon />{' '}
               </ListItemIcon>
               <ListItemText disableTypography className={classes.itemBold} primary="Account" />
           </ListItem>
 
           <ListItem button key="Logout" onClick={this.logoutHandler}>
               <ListItemIcon>
                   {' '}
                   <ExitToAppIcon />{' '}
               </ListItemIcon>
               <ListItemText disableTypography className={classes.itemBold} primary="Logout" />
           </ListItem>
       </List>
   }
 
   renderTabs() {
       if (this.state.isAdmin) {
           return this.renderAdminTabs()
       } else {
           return this.renderTrainerTabs()
       }
   }
 
   chipText() {
       if (this.state.isAdmin) {
           return "Admin"
       } else {
           return this.state.isActive ? "Verified" : "In Verification"
       }
   }
 
   chipColor() {
       if (this.state.isAdmin) {
           return "secondary"
       } else {
           return this.state.isActive ? "secondary" : "default"
       }
   }
 
   render() {
       const { classes } = this.props;
       const container = window !== undefined ? () => window.document.body : undefined;
 
       if (this.state.uiLoading === true) {
           return (
               <div className={classes.root}>
                   {this.state.uiLoading && <CircularProgress className={classes.uiProgess} />}
               </div>
           );
       } else {
           return (
               <div className={classes.root}>
                   <CssBaseline />
                   <AppBar position="fixed" color="secundary" className={classes.appBar}>
 
                       <Toolbar>
                           <IconButton
                               color="inherit"
                               aria-label="open drawer"
                               edge="start"
                               onClick={this.handleDrawerToggle}
                               className={classes.menuButton}
                           >
                               <MenuIcon />
                           </IconButton>
                           <IconButton onClick={this.loadFirstPage}>
                           <Avatar alt="HT" src="/static/images/new-logo.svg" className={classes.avatarSmall} />
                           </IconButton>
                           <div className={classes.appbarIcons}>
 
                               <Typography variant="h6" noWrap>
                                   <Box className={classes.titlePos} fontWeight="fontWeightBold" color="black" m={1} >
                                       Studio
                                   </Box>
                               </Typography>
                               <div className={classes.namePos}>
                                   <Typography variant="body1" noWrap>
                                       <Box fontWeight="fontWeightBold" color="black" m={1} >
                                           {this.state.name}
                                       </Box>
                                   </Typography>
                               </div>
                               <div className={classes.chipPos}>
                               <Chip
                                   variant="outlined"
                                   size="small"
                                   label={this.chipText()}
                                   clickable
                                   color={this.chipColor()}
                               />
                               </div>
                               <IconButton onClick={this.loadAccountPage} sx={{ p: 0 }}>
                                   <Avatar src={this.state.profilePicture} ></Avatar>
                               </IconButton>
 
                           </div>
                       </Toolbar>
                   </AppBar>
 
                   <nav className={classes.drawer} aria-label="mailbox folders">
                       {/* The implementation can be swapped with js to avoid SEO duplication of links. */}
                       <Hidden smUp implementation="css">
                           <Drawer
                               container={container}
                               variant="temporary"
                               anchor={'left'}
                               open={this.state.drawerOpen}
                               onClose={this.handleDrawerToggle}
                               className = {classes.drawerPos}
                               classes={{
                                   paper: classes.drawerPaper,
                               }}
                               ModalProps={{
                                   keepMounted: true, // Better open performance on mobile.
                               }}
                           >
                               <div className={classes.toolbar} />
                               {this.renderTabs()}
                           </Drawer>
                       </Hidden>
                       <Hidden xsDown implementation="css">
                           <Drawer
                               classes={{
                                   paper: classes.drawerPaper,
                               }}
                               variant="permanent"
                               open
                           >
                               <div className={classes.toolbar} />
                               {this.renderTabs()}
                           </Drawer>
                       </Hidden>
                   </nav>
 
                   <div style={{ width: "100%" }}>
                       {this.renderSwitch(this.state.render)}
                   </div>
               </div>
           );
       }
   }
}
 
export default withStyles(styles)(home);
